import React from "react";
import { FaUserShield } from "react-icons/fa";
import { FaGaugeHigh } from "react-icons/fa6";
import { IoIosBrowsers } from "react-icons/io";
import { MdStorage } from "react-icons/md";

const Panel = () => {
  const [active, setActive] = React.useState(0);
  const [fadeIn, setFadeIn] = React.useState(false);
  return (
    <>
      <div id="documentation" style={{ transform: "translateY(-70px)" }}></div>
      <section className="panel-section">
        <div className="container">
          <div className="panel-section-wrapper">
            <div className="left">
              <img
                src={process.env.PUBLIC_URL + "/img/panel-left-border.png"}
                className="d-none d-sm-block"
                alt=""
                data-aos="fade-down"
              />
              <div className="panel-left" data-aos="fade-left">
                {data?.map((item, index) => {
                  return (
                    <div
                      className={`panel--item ${
                        index === active ? "active" : ""
                      }`}
                      key={`panel` + index}
                      style={{
                        background:
                          'url("/img/selected-bg.png") no-repeat center center / cover',
                      }}
                      onClick={() => {
                        setActive(index);
                        setFadeIn(false);
                        setTimeout(() => {
                          setFadeIn(true);
                        }, 0);
                      }}
                    >
                      <div className="icon">{item.icon}</div>
                      <div className="cont">
                        <h6>{item.title}</h6>
                        <p>
                          {item.description}{" "}
                          <a className="learnmore" href={item.url} target="#">
                            Learn More...
                          </a>
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="right" data-aos="fade-right">
              <img
                src={data[active].img}
                className={`w-100 ${fadeIn ? "fadeIn" : ""}`}
                alt=""
              />
            </div>
          </div>
        </div>
        <img
          src={process.env.PUBLIC_URL + "/img/panel-img-ellipsis.png"}
          className="panel-img-ellipsis"
          alt=""
        />
      </section>
      <div className="d-flex justify-content-center">
        <img
          src={process.env.PUBLIC_URL + "/img/solid-line.png"}
          className="mw-100"
          alt=""
        />
      </div>
    </>
  );
};

const data = [
  {
    icon: <FaUserShield />,
    title: "Administrative Panel",
    description:
      "The Carbon panel provides a variety of options for server owners and developers. From general server and player management, to entity inspectors, permission and user management, and more!",
    img: process.env.PUBLIC_URL + "/img/Panel/panel.webp",
    url: "https://docs.carbonmod.gg/owners/modules/admin-module",
  },
  {
    icon: <IoIosBrowsers />,
    title: "Built-in Plugin Browser",
    description:
      "Carbon comes with a new and fresh design for the plugin browser section of the panel. Securely Sign-in with Codefling to access you purchased files!",
    img: process.env.PUBLIC_URL + "/img/Panel/plugins.webp",
    url: "https://docs.carbonmod.gg/owners/modules/admin-module#plugins-tab",
  },
  {
    icon: <FaGaugeHigh />,
    title: "Built-in Mono Profiler",
    description:
      "Created with high performance servers in mind, the heavily customizable profiler is production-ready to help you identify performance issues in your plugins, extensions, Rust and more!",
    img: process.env.PUBLIC_URL + "/img/Panel/profiler.webp",
    url: "https://docs.carbonmod.gg/devs/features/mono-profiler",
  },
  {
    icon: <MdStorage />,
    title: "All In One",
    description:
      "The overall panel is dedicated to making day-to-day much needed features and tweaks, accessible all in one place, speeding up the things you want to get done!",
    img: process.env.PUBLIC_URL + "/img/Panel/allinone.webp",
    url: "https://codefling.com/carbon/carbon",
  },
];
export default Panel;
